import React from 'react'
import { Header } from 'Components/header'
import { ActionButtons } from 'Components/actionButtons'
import { LanguageSelector } from 'Components/languageSelector'

export const IMapContainer = () => {
  return (
    <>
      <Header />
      <ActionButtons />
      <LanguageSelector />
      <p>Interacive Map Accessibility</p>
    </>
  )
}
